<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <g class="float">
      <!-- Canvas/workspace background -->
      <rect
        x="50"
        y="30"
        width="100"
        height="90"
        rx="6"
        fill="#f5f3ff"
        stroke="#c4b5fd"
        stroke-width="1"
        stroke-dasharray="4 2"
      />

      <!-- Connection lines stay behind the draggable blocks -->
      <path
        d="M95 60 L105 60"
        stroke="#c4b5fd"
        stroke-width="1.5"
        stroke-dasharray="3 2"
      />
      <path
        d="M78 68 L78 78"
        stroke="#c4b5fd"
        stroke-width="1.5"
        stroke-dasharray="3 2"
      />
      <path
        d="M122 73 L122 78 L115 78"
        stroke="#c4b5fd"
        stroke-width="1.5"
        stroke-dasharray="3 2"
      />

      <!-- Draggable block 1 - Email template -->
      <g class="drag">
        <rect
          x="60"
          y="40"
          width="35"
          height="28"
          rx="4"
          fill="white"
          stroke="#a78bfa"
          stroke-width="1.5"
        />
        <rect x="65" y="46" width="18" height="3" rx="1.5" fill="#c4b5fd" />
        <rect x="65" y="52" width="25" height="2" rx="1" fill="#ddd6fe" />
        <rect x="65" y="57" width="20" height="2" rx="1" fill="#ddd6fe" />
      </g>

      <!-- Draggable block 2 - Landing page -->
      <g class="drag delay1">
        <rect
          x="105"
          y="45"
          width="35"
          height="28"
          rx="4"
          fill="white"
          stroke="#a78bfa"
          stroke-width="1.5"
        />
        <rect x="110" y="50" width="25" height="12" rx="2" fill="#ede9fe" />
        <rect
          x="115"
          y="65"
          width="15"
          height="4"
          rx="2"
          fill="#7c3aed"
          class="pulse"
        />
      </g>

      <!-- Draggable block 3 - Sender config -->
      <g class="drag delay2">
        <rect
          x="75"
          y="78"
          width="50"
          height="25"
          rx="4"
          fill="white"
          stroke="#a78bfa"
          stroke-width="1.5"
        />
        <circle cx="86" cy="90" r="6" fill="#ede9fe" />
        <rect x="96" y="86" width="22" height="3" rx="1.5" fill="#c4b5fd" />
        <rect x="96" y="92" width="16" height="2" rx="1" fill="#ddd6fe" />
      </g>

      <!-- Cursor indicator -->
      <path d="M145 35 L145 45 L150 42 Z" fill="#7c3aed" class="pulse" />
    </g>
  </svg>
</template>

<style scoped>
@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}
@keyframes drag {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(2px, -2px);
  }
}
@keyframes pulse {
  0%,
  100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}
.float {
  animation: float 4s ease-in-out infinite;
}
.drag {
  animation: drag 3s ease-in-out infinite;
}
.pulse {
  animation: pulse 2.5s ease-in-out infinite;
}
.delay1 {
  animation-delay: 0.5s;
}
.delay2 {
  animation-delay: 1s;
}
</style>
